import { CheckIcon } from "@heroicons/react/solid";
import { useState } from "react";

/**
 * 
 * @param {[]} list 列表项 {id:number,name:String,...} 
 * @param {number} currSel 当前选择项id
 * @param {function} onSelect 
 * @param {hook function ({ item, isSelected})} listItem 选项的hook function，如果为null则使用默认样式
 */
export function ListSelector({ list, currSel, onSelect, listItem }) {
    const [currId, setCurrId] = useState(currSel);

    const ItemHook = listItem;

    const FListItem = ({ item, isSelected }) => {
        const bg = isSelected ?
            " border-link"
            : " border-transparent"

        return <div className={"w-full py-2 px-3 border-2 relative bg-gray-100  rounded-md mb-2 " + bg}>
            {isSelected ? <>
                <div
                    className=" absolute top-0 right-0 w-0 h-0 border-t-[18px] border-l-[18px] border-t-link border-l-transparent">
                </div>
                <div className=" absolute top-[-1px] right-[-1px] flex"><CheckIcon className="w-3 h-3 text-white" /></div>
            </> : <></>}
            {
                ItemHook == null ? item.name
                    : <ItemHook item={item} isSelected={isSelected} />
            }
        </div>
    }


    const onItemSelected = item => {
        setCurrId(item.id);
        if (onSelect)
            onSelect(item);
    }

    const items = [];

    list.forEach(l => {
        items.push(<div key={l.id} className="flex flex-col w-full" onClick={e => {
            onItemSelected(l);
        }}>
            <FListItem item={l} isSelected={currId == l.id} />
        </div>)
    })

    return <div className="w-full flex flex-col flex-1 overflow-y-auto">
        <div className="w-full flex flex-col">
            {items}
        </div>
    </div>
}